import { TestOrder } from "./test-order.model";

export class TestOrderCodeSelectionSession {
  ICDCodeIds: Array<number>;
  SelectedCodes: Array<ICDCode>;

  constructor(testOrder?: TestOrder) {
    testOrder = testOrder || new TestOrder();
    this.ICDCodeIds = testOrder.ICDCodeIds;
    this.SelectedCodes = testOrder.SelectedCodes;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/test-order-code-selection-session.model.ts